// extracted by mini-css-extract-plugin
export default {"titleDecorator":"FjsZWP","pageSummary":"iaTw_a"};